// MIDAS V3 — <verified-line/> grammar (MIDAS-VERIFIED-LINE-1, owner go
// 2026-10-10; owner ruling 2026-10-06 / 2026-10-10 "ask them for marker").
//
// Bot request: machineid-bot-integration/MACHINEID_TODO.md lines 9-24
// (commit 23d7f28, ticket P5-READER-VERIFIED-HEADER-1).
// Spec: IMPLEMENTATION_TEMPLATES/ToDo/MidasChat/VERIFIED_LINE_SPEC.md §1, §3.1;
// our reply draft (frozen contract): ToDo/MidasChat/VERIFIED_LINE_REPLY_DRAFT.md §2.
//
// Wire format (minted by the bot's web formatter, never by the model; final
// `answer` event only; at most once per table):
//   <verified-line/> Overené: vysvetlenia za touto odpoveďou boli skontrolované voči programu PLC.
// as the FIRST thing in its own paragraph directly above a Variant E status
// table. A VOID marker with NO attributes; the sentence after it is plain
// markdown text.
//
// OWNER STANDARD: special rendering is keyed on the explicit marker and on the
// paragraph's POSITION (directly above a detected status table) — NEVER on
// the sentence's wording. Nothing in this module (or its callers / tests)
// reads "Overené" / "Verified" / "Ověřeno".
//
// CLOSED grammar, fail-closed (SEC-REQ-VL-1): the void form with an EMPTY
// attribute blob only. Any attribute, the paired form or the open-only form
// never becomes a sentinel and stays VERBATIM (visible, reportable).
// No decode path at all (SEC-REQ-VL-2): the tag carries nothing to read.
//
// Pure — no React, no DOM.
import { QUIET_LINE_MAX_CHARS } from "./statusQuietLineGrammar";

/** Self-closing only (optional whitespace before `/>`). The `([^>]*?)` blob
 *  must be EMPTY after trim (no attributes, ever). Global — String.replace
 *  only (never call .test/.exec on it). */
export const VERIFIED_LINE_TAG_RE = /<verified-line\b([^>]*?)\/>/gi;

/** A band paragraph is ONE line of prose. Longer / multi-line → not a band
 *  (orphan). Shares the quiet-line ceiling (SEC-REQ-VL-4) so the two fixed
 *  lines around a status table have one cap. */
export const VERIFIED_LINE_MAX_CHARS = QUIET_LINE_MAX_CHARS;

/**
 * Pure placement test used by the rehype pass. `paragraphText` is the hast
 * textOf() of a <p> (sentinels still inside). True when, after optional
 * leading whitespace, the text STARTS with `sentinel`, the remainder contains
 * no line break, and the remainder (NFC, whitespace collapsed, trimmed) is
 * 1..VERIFIED_LINE_MAX_CHARS characters. Wording is NEVER tested.
 *
 * A SECOND sentinel inside the remainder does not disqualify the paragraph
 * (it renders as a hidden orphan marker inside the band). A marker alone (empty
 * remainder) is NOT a band: there is no sentence to style.
 */
export const isVerifiedLineParagraph = (paragraphText: string, sentinel: string): boolean => {
  if (!sentinel) return false;
  const t = (paragraphText || "").replace(/^\s+/, "");
  if (!t.startsWith(sentinel)) return false;
  const rest = t.slice(sentinel.length);
  if (/[\r\n]/.test(rest)) return false;
  const n = rest.normalize("NFC").replace(/\s+/g, " ").trim();
  return n.length > 0 && n.length <= VERIFIED_LINE_MAX_CHARS;
};
